import React, { useEffect, useState } from 'react'
import DateAndTime from '../../features/DateAndTime'
import Countries from '../../features/locations/Countrries'
import StatusChip from '../StatusChip'
import { Skeleton, Tooltip } from '@mui/material'
import GoogleMap from '../Fields/GoogleMap'
import AlertElement from '../AlertElement'

export type BasicDataViewerItemTypes = "text" | "date" | "thumbnail" | "country" | "status" | "map"
export interface IBasicDataViewItem {
    type: BasicDataViewerItemTypes,
    label: string,
    value: string,
    displayLabelNextLine?: boolean,
    customContent?: () => JSX.Element,
    loading?: boolean,
    privateDetails?: boolean,
}

interface IProps {
    items: Array<IBasicDataViewItem>,
    loading?: boolean
}

const BaseSingleDataViewItem = (props: IBasicDataViewItem) => {

    const { type, label, displayLabelNextLine, value, customContent, loading, privateDetails } = props

    const dateAndTime = new DateAndTime()

    const formatValue = (val: string) => {
        switch(type){

            case "date":
                return val ? dateAndTime.formatDateAndTime(val) : ""

            case "country":
                const country = Countries.returnCountryBasedByValue(val)
                return country ? `${country.flag} ${country.name}` : ""

            default:
                return val
        }
    }

    if (type === "map"){
        return(
            <div className={"single-basic-data-viewer-item display-label-as-next-line"}>
                <div className="content-of-single-basic-data-viewer-item">

                    <div className="label-box-of-single-basic-data-viewer-item">
                        <div className="content-of-label-box-of-single-basic-data-viewer-item">
                            <h3>{loading ? <Skeleton variant="text" width={100} /> : label}</h3>
                        </div>
                    </div>

                    <div className="value-box-of-single-basic-data-viewer-item">
                        <div className="content-of-value-box-of-single-basic-data-viewer-item">
                            {value ? <GoogleMap url={value} /> : <AlertElement type="info" message="Google Maps link wasn't provided" />}
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    return(
        <div className={displayLabelNextLine ? "single-basic-data-viewer-item display-label-as-next-line" : "single-basic-data-viewer-item"}>
            <div className="content-of-single-basic-data-viewer-item">

                <div className="label-box-of-single-basic-data-viewer-item">
                    <div className="content-of-label-box-of-single-basic-data-viewer-item">
                        <h3>{loading ? <Skeleton variant="text" width={100} /> : label}</h3>
                    </div>
                </div>

                <div className="value-box-of-single-basic-data-viewer-item">
                    <div className="content-of-value-box-of-single-basic-data-viewer-item">
                        {privateDetails ? <StatusChip type="restricted" /> : loading ? <Skeleton variant="text" width={100} /> : customContent ? customContent() : type === "status" ? <StatusChip type={value} /> : <h3>{value ? formatValue(value) : "-"}</h3>}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default function BasicDataViewer(props: IProps) {

    const items = props.items

    return(
        <div className="basic-data-viewer-container">
            <div className="content-of-basic-data-viewer-container">
                {items.length > 0 && items.map((item, index) => <BaseSingleDataViewItem loading={props.loading} {...item} key={index} />)}
            </div>
        </div>
    )
}